import { useState, useEffect } from "react"
import { Header } from "@/components/landing/header"
import { HeroSection } from "@/components/landing/hero-section"
import { StatsSection } from "@/components/landing/stats-section"
import { CapabilitiesSection } from "@/components/landing/capabilities-section"
import { WorkflowSection } from "@/components/landing/workflow-section"
import { CaseStudiesSection } from "@/components/landing/case-studies-section"
import { VorroDifferenceSection } from "@/components/landing/vorro-difference-section"
import { CTASection } from "@/components/landing/cta-section"
import { Footer } from "@/components/landing/footer"
import { ThankYouPage } from "@/components/landing/thank-you-page"
import { LeadAdmin } from "@/components/admin/lead-admin"

export default function App() {
  const [currentRoute, setCurrentRoute] = useState("")

  useEffect(() => {
    // Check initial hash - only handle routes that start with #/
    const getRoute = () => {
      const hash = window.location.hash
      if (hash.startsWith('#/')) {
        // Strip '#/' and any query string Zoho appended (e.g. ?booking_id=...)
        return hash.slice(2).split('?')[0]
      }
      return ''
    }
    
    setCurrentRoute(getRoute())

    // Listen for hash changes
    const handleHashChange = () => {
      setCurrentRoute(getRoute())
    }

    window.addEventListener('hashchange', handleHashChange)
    return () => window.removeEventListener('hashchange', handleHashChange)
  }, [])

  // Render LeadAdmin for /#/n8nLeadAdmin route
  if (currentRoute === 'n8nLeadAdmin') {
    return <LeadAdmin />
  }

  // Render thank-you page after a successful demo booking
  if (currentRoute === 'thank-you') {
    return <ThankYouPage />
  }

  // Default: render landing page
  return (
    <div className="min-h-screen bg-white font-sans antialiased">
      <Header />
      <main>
        <HeroSection />
        <StatsSection />
        <CapabilitiesSection />
        <WorkflowSection />
        <CaseStudiesSection />
        <VorroDifferenceSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  )
}
